import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { IconTextListComponent } from './icon-text-list/icon-text-list.component';
import { ImageTextListComponent } from './image-text-list/image-text-list.component';
import { ImageUrlPipe } from '@frontend/shared';



@NgModule({
  declarations: [
    IconTextListComponent,
    ImageTextListComponent,
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    ImageUrlPipe,
  ],
  exports: [
    IconTextListComponent,
    ImageTextListComponent,
  ]
})
export class TextListsModule { }
